module.exports = __webpack_public_path__ + "static/media/Icon-sotrudnic.8a89ffb0.svg";